import { ResearchType, ResearchBranch } from "../types/research.js";
export const RESEARCH_DEFINITIONS = {
    // Economy branch
    [ResearchType.CONSERVATION]: {
        type: ResearchType.CONSERVATION,
        branch: ResearchBranch.ECONOMY,
        name: "Conservation",
        description: "Increases warehouse storage capacity.",
        maxLevel: 10,
        baseCost: { wood: 100, marble: 50 },
        baseTime: 600, // 10 min
        effect: "+10% storage capacity per level",
    },
    [ResearchType.PULLEY]: {
        type: ResearchType.PULLEY,
        branch: ResearchBranch.ECONOMY,
        name: "Pulley",
        description: "Speeds up building construction.",
        maxLevel: 10,
        baseCost: { wood: 150, marble: 80 },
        baseTime: 900, // 15 min
        prerequisite: { type: ResearchType.CONSERVATION, level: 2 },
        effect: "-5% building time per level",
    },
    [ResearchType.CARTOGRAPHY]: {
        type: ResearchType.CARTOGRAPHY,
        branch: ResearchBranch.ECONOMY,
        name: "Cartography",
        description: "Reduces travel time for ships and armies.",
        maxLevel: 10,
        baseCost: { wood: 200, crystal: 100 },
        baseTime: 1200, // 20 min
        prerequisite: { type: ResearchType.PULLEY, level: 3 },
        effect: "-10% travel time per level",
    },
    [ResearchType.TAXATION]: {
        type: ResearchType.TAXATION,
        branch: ResearchBranch.ECONOMY,
        name: "Taxation",
        description: "Increases gold income from your population.",
        maxLevel: 10,
        baseCost: { wood: 120, marble: 60 },
        baseTime: 720, // 12 min
        prerequisite: { type: ResearchType.CONSERVATION, level: 1 },
        effect: "+8% gold income per level",
    },
    [ResearchType.IRRIGATION]: {
        type: ResearchType.IRRIGATION,
        branch: ResearchBranch.ECONOMY,
        name: "Irrigation",
        description: "Boosts resource production in all your cities.",
        maxLevel: 10,
        baseCost: { wood: 180, marble: 100, crystal: 50 },
        baseTime: 1500, // 25 min
        prerequisite: { type: ResearchType.TAXATION, level: 3 },
        effect: "+5% resource production per level",
    },
    // Military branch
    [ResearchType.BRONZE_ARMOR]: {
        type: ResearchType.BRONZE_ARMOR,
        branch: ResearchBranch.MILITARY,
        name: "Bronze Armor",
        description: "Improves the defense of all your units.",
        maxLevel: 10,
        baseCost: { wood: 100, sulfur: 80 },
        baseTime: 600, // 10 min
        effect: "+5% unit defense per level",
    },
    [ResearchType.SHARPENED_BLADES]: {
        type: ResearchType.SHARPENED_BLADES,
        branch: ResearchBranch.MILITARY,
        name: "Sharpened Blades",
        description: "Increases the attack power of all your units.",
        maxLevel: 10,
        baseCost: { wood: 120, sulfur: 100 },
        baseTime: 720, // 12 min
        prerequisite: { type: ResearchType.BRONZE_ARMOR, level: 2 },
        effect: "+5% unit attack per level",
    },
    [ResearchType.FORMATIONS]: {
        type: ResearchType.FORMATIONS,
        branch: ResearchBranch.MILITARY,
        name: "Formations",
        description: "Unlock advanced tactical formations for your army.",
        maxLevel: 10,
        baseCost: { wood: 200, sulfur: 150, crystal: 50 },
        baseTime: 1200, // 20 min
        prerequisite: { type: ResearchType.SHARPENED_BLADES, level: 3 },
        effect: "+3% overall combat effectiveness per level",
    },
    [ResearchType.SIEGE_CRAFT]: {
        type: ResearchType.SIEGE_CRAFT,
        branch: ResearchBranch.MILITARY,
        name: "Siege Craft",
        description: "Improves siege weapons and wall-breaking capability.",
        maxLevel: 10,
        baseCost: { wood: 250, sulfur: 200, marble: 100 },
        baseTime: 1800, // 30 min
        prerequisite: { type: ResearchType.FORMATIONS, level: 2 },
        effect: "+10% siege damage per level",
    },
    [ResearchType.NAVAL_WARFARE]: {
        type: ResearchType.NAVAL_WARFARE,
        branch: ResearchBranch.MILITARY,
        name: "Naval Warfare",
        description: "Improves the combat strength of your naval fleet.",
        maxLevel: 10,
        baseCost: { wood: 200, sulfur: 150, crystal: 80 },
        baseTime: 1500, // 25 min
        prerequisite: { type: ResearchType.BRONZE_ARMOR, level: 3 },
        effect: "+8% naval combat power per level",
    },
};
/**
 * Calculate research cost at a given level.
 * Formula: baseCost * 1.6^(level - 1)
 */
export function getResearchCost(type, level) {
    const def = RESEARCH_DEFINITIONS[type];
    const multiplier = Math.pow(1.6, level - 1);
    return {
        wood: Math.floor((def.baseCost.wood ?? 0) * multiplier),
        marble: Math.floor((def.baseCost.marble ?? 0) * multiplier),
        crystal: Math.floor((def.baseCost.crystal ?? 0) * multiplier),
        sulfur: Math.floor((def.baseCost.sulfur ?? 0) * multiplier),
    };
}
/**
 * Calculate research time at a given level (in seconds).
 * Formula: baseTime * 1.5^(level - 1)
 */
export function getResearchTime(type, level) {
    return Math.floor(RESEARCH_DEFINITIONS[type].baseTime * Math.pow(1.5, level - 1));
}
//# sourceMappingURL=research.js.map